<template>
  <div class="my-auto">
    <v-card elevation="4" class="mx-auto my-16" height="auto" max-width="400" outlined>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="px-4">
          <v-img class="logo" src="@/assets/layout/nerdof_icon.png"></v-img>
          <v-card-title class="title justify-center pa-0 font-weight-bold">
            Nerdof
          </v-card-title>
          <p class="text-center">Super Admin Login</p>
          <v-col md="12" class="my-2">
            <v-text-field
              type="text"
              v-model="username"
              label="username"
              placeholder="email / username"
              outlined
              required
              hide-details="auto"
              :rules="usernameRules"
              clearable
              clear-icon="mdi-close mb-2"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="my-2">
            <v-text-field
              :type="showPwd ? 'text' : 'password'"
              v-model="password"
              label="password"
              placeholder="password"
              outlined
              required
              hide-details="auto"
              :rules="passwordRules"
              clearable
              clear-icon="mdi-close mb-2"
              :append-icon="showPwd ? 'mdi-eye mb-2' : 'mdi-eye-off mb-2'"
              @click:append="showPwd = !showPwd"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="my-2 text-center">
            <v-btn
              class="btn-login"
              color="primary"
              depressed
              elevation="2"
              @click="checkLogin"
              >Submit</v-btn
            >
          </v-col>
          <div class="mx-3">
            <warnningComponent
              v-if="warning.showWarnnig"
              v-bind:textInfo.sync="warning.textWarning"
              v-bind:typestatus.sync="warning.typeWarning"
              v-bind:alert.sync="warning.showWarnnig"
              v-bind:background.sync="warning.color"
            ></warnningComponent>
          </div>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { checkCompany, loginSuperAdmin, getInfo, logout } from "@/service/account/login";
import { checkDevice } from "@/helper/checkDevice";
import warnningComponent from "@/components/warningAlert";
export default {
  name: "login",
  components: {
    warnningComponent,
  },
  data() {
    return {
      isShow: false,
      valid: true,
      showPwd: false,
      username: "",
      usernameRules: [(v) => !!v || "Username is required"],
      password: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        // (v) => (v && v.length > 8) || "Password must be at least 8 characters",
      ],
      warning: {
        textWarning: "",
        typeWarning: "",
        showWarnnig: "",
        color: "white",
      },
    };
  },
  methods: {
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    resetForm() {
      this.$refs.form.reset();
    },
    async checkLogin() {
      if (this.$refs.form.validate()) {
        let company = await checkCompany({
          username: this.username,
        });

        if (!company) {
          this.alertWarning("username / email incorrect", "warning");
        } else if (company.length > 1) {
          this.alertWarning("username / email incorrect", "warning");
        } else {
          let device = checkDevice();
          let result = await loginSuperAdmin({
            id: company[0]._id,
            password: this.password,
            platform: device.platform,
            osversion: device.osversion,
            device: device.device,
          });
          if (result.data.status === true) {
            await localStorage.setItem("x-session-token", result.data.result.token);
            await localStorage.setItem("expWeb", result.data.result.endTime);
            let resultInfo = await getInfo();
            if (
              resultInfo.info.isTeacher !== "y" &&
              !resultInfo.info.permission.adminCompany
            ) {
              await this.alertWarning("access denied", "warning");
              await logout();
              await this.$store.commit("clear");
              await localStorage.clear();
              await this.resetForm();
              return;
            }
            this.alertWarning("complete", "success");
            await this.$store.commit("setTheme", resultInfo.info);
            this.$router.push({ path: "/company" });
          } else {
            this.alertWarning("password incorrect", "warning");
          }
        }
      }
    },
    alertWarning(text, type) {
      this.warning.textWarning = text;
      this.warning.typeWarning = type;
      this.warning.showWarnnig = true;
      this.warning.color = "";
      setInterval(() => {
        this.warning.showWarnnig = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.logo {
  width: 20%;
  margin: auto;
}
.btn-login {
  width: 100%;
}
</style>
